import { render, staticRenderFns } from "./counts.vue?vue&type=template&id=973d8cf0&scoped=true"
import script from "./counts.vue?vue&type=script&lang=js"
export * from "./counts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973d8cf0",
  null
  
)

export default component.exports